import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorStatusBadge} from 'entities/monitor';
import {IDomainMonitorItem} from 'features/domain/model/DomainMonitor/IDomainMonitor';
import useDomainMonitorChecksSummary from 'features/domain/model/useDomainMonitorChecksSummary';
import {getFormattedDate} from 'shared/lib/datetime';

import DomainCheckValue from '../../DomainCheckValue/DomainCheckValue';

import styles from './DomainMonitorChecksSummary.module.scss';

interface IDomainMonitorChecksSummaryProps {
    domainMonitor: IDomainMonitorItem,
}

const DomainMonitorChecksSummary: React.FC<IDomainMonitorChecksSummaryProps> = ({domainMonitor}) => {
    const {tzString, dateFormat, dateTimeFormat, isRknVisible} = useDomainMonitorChecksSummary();

    const yesNo = (value: boolean | null) => (value ? t`Да` : t`Нет`);

    return (
        <div className={styles.section}>
            <span className={styles.state}>
                {t`Состояние`}: <MonitorStatusBadge status={domainMonitor.active ? 'active' : 'paused'}/>
            </span>

            <span className={styles.line}/>

            <div className={styles.grid}>
                <span className={styles.item}>
                    <span className={styles.label}>{t`SSL действителен до`}:</span>
                    <DomainCheckValue
                        tariffCondition="monitor_ssl_enabled"
                        isWatched={domainMonitor.ssl_watch}
                        value={domainMonitor.ssl_active_to}
                    >
                        {getFormattedDate(domainMonitor.ssl_active_to, {format: dateFormat, tzString})}
                    </DomainCheckValue>
                </span>
                <span className={styles.item}>
                    <span className={styles.label}>{t`Домен оплачен до`}:</span>
                    <DomainCheckValue
                        tariffCondition="monitor_domain_watch_enabled"
                        isWatched={domainMonitor.domain_watch}
                        value={domainMonitor.domain_active_to}
                    >
                        {getFormattedDate(domainMonitor.domain_active_to, {format: dateFormat, tzString})}
                    </DomainCheckValue>
                </span>
                <span className={styles.item}>
                    <span className={styles.label}>{t`Редирект на HTTPS`}:</span>
                    <DomainCheckValue
                        tariffCondition="monitor_ssl_redirect_watch_enabled"
                        isWatched={domainMonitor.ssl_redirect_watch}
                        value={domainMonitor.ssl_redirect}
                    >
                        {yesNo(domainMonitor.ssl_redirect)}
                    </DomainCheckValue>
                </span>
                <span className={styles.item}>
                    <span className={styles.label}>{t`Мониторинг robots.txt`}:</span>
                    {domainMonitor.robots_txt_watch ? t`Включён` : t`Выключен`}
                </span>
                {isRknVisible && (
                    <span className={styles.item}>
                        <span className={styles.label}>{t`Блокировка РКН`}:</span>
                        <DomainCheckValue
                            tariffCondition="monitor_rkn_watch_enabled"
                            isWatched={domainMonitor.rkn_watch}
                            value={domainMonitor.rkn_block}
                        >
                            {yesNo(domainMonitor.rkn_block)}
                        </DomainCheckValue>
                    </span>
                )}
                <span className={styles.item}>
                    <span className={styles.label}>{t`Монитор создан`}:</span>
                    {getFormattedDate(domainMonitor.created_at, {format: dateTimeFormat, tzString})}
                </span>
                <span className={styles.item}>
                    <span className={styles.label}>{t`Обновлён`}:</span>
                    {getFormattedDate(domainMonitor.updated_at, {format: dateTimeFormat, tzString})}
                </span>
            </div>
        </div>
    );
};

export default DomainMonitorChecksSummary;
